import { render, staticRenderFns } from "./add-intervention.vue?vue&type=template&id=62aef60c"
import script from "./add-intervention.vue?vue&type=script&lang=js"
export * from "./add-intervention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports